import { Injectable } from '@angular/core';
import { Quarantine } from '../models/Quarantine';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { Pagination } from '../models';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class QuarantineService  extends BaseApiService<Quarantine> {
  get cacheKey(): StorageKey {
    return StorageKey.quarantineServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.omniaCoreApiUrl}/v1/report/reportQuarantine`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  list(params: {[params: string]: string}): Promise<Pagination<Quarantine>> {
    return super.list(params);
  }

  protected parse(obj) {
    return Quarantine.parse(obj);
  }

  protected unparse(obj) {
    return Quarantine.unparse(obj);
  }

}
